import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackMetaPixelEvent } from "@src/utils/helpers/meta-pixel";

/**
 * The Meta Pixel snippet in index.html fires the first PageView. Client-side route
 * changes don't reload the page, so this fires PageView for every later path change.
 */
export default function MetaPixelPageView() {
  const { pathname } = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    trackMetaPixelEvent("PageView");
  }, [pathname]);

  return null;
}
